<template>
  <div :class="$style.container">
    <div :class="$style.icon" :data-icon="src"></div>
  </div>
</template>

<script>
import { TimelineMax, Power3 } from 'gsap'
import { getMixedLength } from '@/scripts/utils'

export default {
  props: ['src', 'index'],

  data() {
    return {
      isEntered: false
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.setIcons()

      this.$smooth.scrollbar.addListener(() => {
        if (this.$smooth.scrollbar.isVisible(this.$el) && !this.isEntered) {
          this.isEntered = true
          this.animateIcons()
        }
      });
    });
  },

  methods: {
    setIcons(needFlash = false) {
      const DOMIcons = Array.from(this.$el.querySelectorAll('[data-icon]'));

      DOMIcons.forEach((icon) => {
        const url = icon.getAttribute('data-icon');

        fetch(url).then(response => response.text()).then((svg) => {
          const localIcon = icon;
          localIcon.innerHTML = svg;

          if (!needFlash) {
            const strokes = Array.from(localIcon.querySelectorAll('[data-name="stroke"]'));
            const fills = Array.from(localIcon.querySelectorAll('[data-name="fill"]'));

            strokes.forEach((stroke) => {
              const length = Math.ceil(stroke.getTotalLength())

              TweenMax.set(stroke, {
                // opacity: 0,
                strokeDasharray: length,
                strokeDashoffset: length,
              });
            });

            TweenMax.set(fills, { autoAlpha: 0 });
          }
        });
      });
    },

    animateIcons(reverse) {
      const paths = Array.from(this.$el.querySelectorAll('[data-name="stroke"]'));
      const fills = Array.from(this.$el.querySelectorAll('[data-name="fill"]'));
      const timeline = new TimelineMax({ delay: 0.2 + (this.index * 0.4) })

      timeline
        .addLabel('start')
        .staggerTo(paths, 0.8, {
          ease: Power3.easeInOut,
          cycle: {
            strokeDashoffset: (index, target) => {
              return !reverse ? 0 : Math.ceil(target.getTotalLength()) // eslint-disable-line
            }
          },
        }, 0.1, 'start')
        .staggerTo(fills, 0.8, {
          autoAlpha: !reverse ? 1 : 0,
          ease: Power3.easeInOut,
        }, 0.1, 'start+=0.3')
    }
  }
}
</script>

<style lang="scss" module>
.container {
  padding: $small-margin;
}

.icon {
  width: 100%;
  height: 100%;

  svg {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BigIcon.vue